import axios from "axios";
import React, { useEffect, useState } from "react";
import style from "./dashboard.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faUser } from "@fortawesome/free-solid-svg-icons";
import BodyLoading from "../../../modules/Loading/BodyLoading";
import { Link } from "react-router-dom";

export default function Dashboard() {
  const [loading, setLoading] = useState(true);
  const [userList, setUserlist] = useState([]);

  const fetchUser = async () => {
    try {
      setLoading(true);
      const response = await axios.get("/admin-dashboard");
      if (response.data.status === 200) {
        setUserlist(response.data.users);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchUser();
  }, []);

  return (
    <div className="container">
      <div className="mt-5 d-flex ">
        {loading ? <BodyLoading /> : null}

        <div className={`${style.boxItem}`}>
          <div className={`${style.boxItemWrap}`}>
            <div className={`${style.boxItemsLeft}`}>
              <FontAwesomeIcon icon={faUser} />
            </div>
            <div className={`${style.boxItemsRight}`}>
              <p>total users</p>
              <h4>{userList}</h4>
            </div>
          </div>
          <hr className={`${style.boxItemsHr}`}></hr>
          <div className={`${style.boxItemFooter}`}>
            <Link to="/admin/users" className="">
              See All Users
              <span>
                <FontAwesomeIcon icon={faArrowRight} />
              </span>
            </Link>
          </div>
        </div>

        <div className={`${style.boxItem}`}>
          <div className={`${style.boxItemWrap}`}>
            <div className={`${style.boxItemsLeft}`}>
              <FontAwesomeIcon icon={faUser} />
            </div>
            <div className={`${style.boxItemsRight}`}>
              <p>total users</p>
              <h4>{userList}</h4>
            </div>
          </div>
          <hr className={`${style.boxItemsHr}`}></hr>
          <div className={`${style.boxItemFooter}`}>
            <Link to="/admin/users" className="">
              See All Users
              <span>
                <FontAwesomeIcon icon={faArrowRight} />
              </span>
            </Link>
          </div>
        </div>

        <div className={`${style.boxItem}`}>
          <div className={`${style.boxItemWrap}`}>
            <div className={`${style.boxItemsLeft}`}>
              <FontAwesomeIcon icon={faUser} />
            </div>
            <div className={`${style.boxItemsRight}`}>
              <p>total users</p>
              <h4>{userList}</h4>
            </div>
          </div>
          <hr className={`${style.boxItemsHr}`}></hr>
          <div className={`${style.boxItemFooter}`}>
            <Link to="/admin/users" className="">
              See All Users
              <span>
                <FontAwesomeIcon icon={faArrowRight} />
              </span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
